import { render, staticRenderFns } from "./home-old.vue?vue&type=template&id=08828543&scoped=true&"
import script from "./home-old.vue?vue&type=script&lang=js&"
export * from "./home-old.vue?vue&type=script&lang=js&"
import style0 from "./home-old.vue?vue&type=style&index=0&id=08828543&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08828543",
  null
  
)

export default component.exports